import React from "react";
import { useNavigate } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#0B0F17] flex items-center justify-center p-6">
      <div className="text-center max-w-sm" data-testid="payment-cancel">
        <XCircle className="w-14 h-14 text-slate-500 mx-auto mb-5" />
        <h1 className="font-heading text-2xl font-bold mb-2">Checkout cancelled</h1>
        <p className="text-slate-400 text-sm mb-6">
          No charge was made. You can pick a plan whenever you're ready.
        </p>
        <button
          data-testid="back-to-plans-button"
          onClick={() => navigate("/")}
          className="px-6 py-3 rounded-xl bg-blue-600 hover:bg-blue-500 text-white font-semibold transition-colors"
        >
          Back to plans
        </button>
      </div>
    </div>
  );
}
